'use client';
import { useTranslation } from 'react-i18next';
import { type UserFollow } from '@/lib/api';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { useNavigate } from 'react-router-dom';
import { VipUserIcon } from '@/app/const/svg'
import { Tooltip } from 'antd';

export function UserAvatar({
  size = 10,
  userInfo,
  liveStatus = true,
  hideLiveStatus = false,
  forbidLink = false,
  openNewWindow = false,
  liveClassName = '',
  liveStatusClassName = '',
  onClick
}: {
  size?: number;
  userInfo: UserFollow;
  liveStatus?: boolean;
  hideLiveStatus?: boolean;
  forbidLink?: boolean;
  openNewWindow?: boolean;
  liveClassName?: string;
  liveStatusClassName?: string;
  onClick?: () => void;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return userInfo.status === 0 || !liveStatus ? (
    <div className='relative'>
      <Avatar
        className={`w-${size} h-${size}`}
        onClick={() => {
          if (onClick) {
            onClick();
            return;
          }
          if (!userInfo.roomId || forbidLink) return;
          // 回放功能
          if (openNewWindow) {
            window.open(`/live/detail?id=${userInfo.roomId}`, '_blank');
          }
          else {
            navigate(`/live/detail?id=${userInfo.roomId}`);
          }
        }}
      >
        <AvatarImage src={userInfo?.avatar} />
        <AvatarFallback>{userInfo?.userName?.charAt(0)}</AvatarFallback>
      </Avatar>
      {!!userInfo.isOfficial && (
        <Tooltip title={t('liveDetail.officialVerified')}>
          <div 
            className='absolute -right-0.5 -bottom-0.5 bg-primary rounded-full flex items-center justify-center border border-background-card cursor-pointer transition-all duration-300 p-0.5'
          >
            <VipUserIcon className='size-3 text-font-reverse' />
          </div>
        </Tooltip>
      )}
    </div>
  ) : (
    <div
      className="co-avatar-living cursor-pointer"
      onClick={() => {
        if (onClick) {
          onClick();
          return;
        }
        if (forbidLink) return;
        if (openNewWindow) {
          window.open(`/live/detail?id=${userInfo.roomId}`, '_blank');
        }
        else {
          navigate(`/live/detail?id=${userInfo.roomId}`);
        }
      }}
    >
      <Avatar className={`w-${size} h-${size} co-avatar-info`}>
        <AvatarImage src={userInfo?.avatar} />
        <AvatarFallback>{userInfo?.userName?.charAt(0)}</AvatarFallback>
      </Avatar>
      <span className={`co-avatar-border ${liveClassName}`}></span>
      <span className="co-avatar-border co-avatar-border-light"></span>
      {!hideLiveStatus && (
        <Badge 
          className={`co-avatar-border-tag absolute whitespace-nowrap md:px-1.5 md:py-0 ${liveStatusClassName}`}
        >
          {!!userInfo.isOfficial && (
            <Tooltip title={t('officialVerified')}>
              <VipUserIcon className='size-3 text-font-reverse' />
            </Tooltip>
          )}
          {t('live.liveing')}
        </Badge>
      )}
    </div>
  )
}
